/**
 * @desc 文件处理
 * @author dhx
 * @time 2024.1.20
 */

// 通过文件地址获取文件内容
export const getFile = async function(url) {
  const response = await fetch(url, { method: 'GET' });
  return await response.blob();
};

// 将文件读取成base64格式的内容
export const base64Handle = function(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = function(e) {
      const base64Data = e.target.result;
      resolve(base64Data);
    };

    reader.readAsDataURL(file);
  });
};

const omit = function(obj, keys) /*忽略*/{
  return Object.keys(obj).reduce((pre, key) => {
    if (!keys.includes(key)) {
      pre[key] = obj[key];
    }
    return pre;
  }, {});
}

const include = function(obj, keys) /*攘括*/{
  return Object.keys(obj).reduce((pre, key) => {
    if (keys.includes(key)) {
      pre[key] = obj[key];
    }
    return pre;
  }, {});
}

const formatObj = function(origin, target) {
  if (target && origin)
    return Object.keys(target).map(key => {
      origin[key] && (target[key] = origin[key]);
    });
}

export const handleObj = { omit, include, formatObj};

export const isEmpty = obj => /** 判断空对象 */ {
  if (obj === null || obj === undefined) return true;
  if (typeof obj === "object") return Object.keys(obj).length === 0
}


// WEBPACK FOOTER //
// ./src/utils/tools.js